namespace Areas {
    "use strict";

    const columnChooserButtonName = "columnChooserButton";

    export function addColumnChooser(e: any) {
        const grid: DevExpress.ui.dxDataGrid = e.component;
        
        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: columnChooserButtonName, "class": "dx-datagrid-column-chooser-button" },
            text: "Columns",
            hint: "Choose columns to show/hide",
            type: "normal",
            icon: "column-chooser",
            onClick: showColumnChooser(grid)
        }, "after");

    } 
  
    function showColumnChooser(grid: DevExpress.ui.dxDataGrid) {
        return (e: any) => {
            grid.showColumnChooser();
        }
    }   
    
}